import axiosInstance from "../../config/Axios";

export const getProjections = async ({ page = 1, limit = 10, ...filters } = {}) => {
  try {
    const offset = (page - 1) * limit;
    const response = await axiosInstance({
      method: "get",
      url: "/api/projections/",
      params: {
        limit,
        offset,
        ...filters
      }
    });
    return {
      data: response.data.results,
      total: response.data.count,
      next: response.data.next,
      previous: response.data.previous
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getProjectionById = async (id) => {
  try {
    return await axiosInstance({
      method: "get",
      url: `/api/projections/${id}/`,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createProjection = async (projectionData) => {
  try {
    return await axiosInstance({
      method: "post",
      url: "/api/projections/",
      data: projectionData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateProjection = async (id, projectionData) => {
  try {
    return await axiosInstance({
      method: "put",
      url: `/api/projections/${id}/`,
      data: projectionData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteProjection = async (id) => {
  if (!id) {
    return Promise.reject(new Error("Projection ID is required"));
  }
  try {
    const response = await axiosInstance({
      method: "delete",
      url: `/api/projections/${id}/`,
    });
    return response;
  } catch (error) {
    console.error("Delete API Error:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
};

export const calculateProjection = async (data) => {
  try {
    return await axiosInstance({
      method: "post",
      url: "/api/projections/calculate_projection/",
      data,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const generateProjection = async (data) => {
  try {
    return await axiosInstance({
      method: "post",
      url: "/api/projections/generate/",
      data,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const manualCreateProjection = async (projectionData) => {
  try {
    return await axiosInstance({
      method: "post",
      url: "/api/projections/manual_create/",
      data: projectionData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const manualEditProjection = async (id, projectionData) => {
  try {
    return await axiosInstance({
      method: "patch",
      url: `/api/projections/${id}/manual_edit/`,
      data: projectionData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getProjections,
  getProjectionById,
  createProjection,
  updateProjection,
  deleteProjection,
  calculateProjection,
  generateProjection,
  manualCreateProjection,
  manualEditProjection,
};
